<template>
    <main-content>
        <div class="shadow-sm bg-white rounded px-4 pb-4">
            <form id="submit_form">
                <div class="row">
                    <div class="col-12 my-2">
                       <div class="back-flex">
                            <div class="btn-width-100">
                                <router-link to="/wallets" class="btn btn-success my-2 btn-width-100">{{ $t('label.back') }}</router-link>
                            </div>
                       </div>
                       <div class="h5" v-text="$t('wallets.label.charge_wallet')"></div>
                    </div>
                    <div class="col-12 col-md-6 my-2">
                        <label v-text="$t('wallets.label.amount_rial')"></label>
                        <amount-input
                                item_id="amount"
                                item_name="amount"
                                :item="form_data"
                        ></amount-input>
                    </div>
                    <div class="col-12 col-md-6 my-2">
                        <label for="pan" v-text="$t('label.pan')"></label>
                        <input class="form-control" id="pan" name="pan" v-model="form_data.pan">
                    </div>
                    <div class="col-12 col-md-6 my-2">
                        <label for="pin" v-text="$t('label.dynamic_pin')"></label>
                        <input class="form-control" id="pin" name="pin" v-model="form_data.pin">
                    </div>
                    <div v-if="step === 'otp'"
                         class="col-12 mt-4"
                    >
                        <button @click="submitOtp"
                                class="btn btn-success"
                                type="button"
                                v-text="otp_form_meta_data.submit_btn_text"
                        ></button>
                    </div>
                    <div v-else
                         class="col-12 mt-4">
                        <button @click="chargeByBill"
                                class="btn btn-success"
                                type="button"
                                v-text="form_meta_data.submit_btn_text"
                        ></button>
                    </div>
                </div>
            </form>
        </div>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content';
    import {i18n} from '@/plugins/i18n';
    import $ from 'jquery';
    import {walletService} from '@/common/api.service';
    import AmountInput from "@/components/custom-elements/amount-input";

    export default {
        components: {
            mainContent,
            AmountInput,
        },
        data() {
            return {
                step: 'otp',
                invoice_id: '',
                form_data: {
                    amount: '',
                    pan: '',
                    pin: '',
                },
                otp_form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('btn.get_pin'),
                },
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('wallets.label.pay'),
                },
            };
        },
        methods: {
            submitOtp() {
                let form = $('#submit_form');

                form.validate({
                    rules: {
                        amount: {
                            required: true,
                        },
                        pan: {
                            required: true,
                        },
                    }
                });

                if (!form.valid()) {
                    return;
                }

                this.otp_form_meta_data.submit_btn_progress = true;

                let params = {
                    wallet_prefix: 'A',
                    amount: this.form_data.amount,
                    pan: this.form_data.pan,
                };

                walletService.getPin(params).then(response => {
                    this.invoice_id = response.data.data.invoice_id;
                    this.step = 'charge';
                    this.showMsg(form,'success','رمز دوم پویاارسال شد')
                }).catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    this.showMsg(form, 'danger', response.data.message);
                }).finally(() => {
                        this.otp_form_meta_data.submit_btn_progress = false;
                    }
                );
            },
            chargeByBill() {
                let form = $('#submit_form');

                form.validate({
                    rules: {
                        pin: {
                            required: true,
                        },
                    }
                });

                if (!form.valid()) {
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;

                let params = {
                    pin: this.form_data.pin,
                    invoice_id: this.invoice_id,
                    pan: this.form_data.pan,
                };

                walletService.chargeByBill(params, this.$route.params.hashid).then(response => {
                    this.$router.push('/wallets');
                }).catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    this.showMsg(form, 'danger', response.data.message);
                }).finally(() => {
                    this.form_meta_data.submit_btn_progress = false;
                });
            },
        },
    }
</script>

<style scoped>
.back-flex {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
}
</style>